export const PlayClickAudio = () => {
  const clickAudio = new Audio(
    `${process.env.PUBLIC_URL}/knockknock/audio/clicking.mp3`
  );
  if (clickAudio) {
    clickAudio.currentTime = 0;
    clickAudio.play();
  }
};

export const ModalAudio = {
  arrival: new Audio(
    `${process.env.PUBLIC_URL}/knockknock/audio/knockknock3.mp3`
  ),
  cancel: new Audio(`${process.env.PUBLIC_URL}/knockknock/audio/bell.mp3`),
  // morningCall: new Audio(`${process.env.PUBLIC_URL}/knockknock/audio/morningCall.mp3`),
};

export const FindItemAudio = {
  bgm: new Audio(`${process.env.PUBLIC_URL}/knockknock/audio/gameBgm.mp3`),
  start: new Audio(`${process.env.PUBLIC_URL}/knockknock/audio/gameStart.mp3`),
  correct: new Audio(
    `${process.env.PUBLIC_URL}/knockknock/audio/gameCorrect.mp3`
  ),
  wrong: new Audio(`${process.env.PUBLIC_URL}/knockknock/audio/gameWrong.mp3`),
};

export const arraivalAudio = new Audio(
  `${process.env.PUBLIC_URL}/knockknock/audio/knockknock3.mp3`
);
export const cancelAudio = new Audio(
  `${process.env.PUBLIC_URL}/knockknock/audio/bell.mp3`
);
export const MorningCallAudio = new Audio(
  `${process.env.PUBLIC_URL}/knockknock/audio/morningCall.mp3`
);

export const CallWaitAudio = new Audio(
  `${process.env.PUBLIC_URL}/knockknock/audio/call_wait_audio.mp3`
);

export const CallEndAudio = new Audio(
  `${process.env.PUBLIC_URL}/knockknock/audio/call_end_audio.mp3`
);

export const CallRingtoneAudio = new Audio(
  `${process.env.PUBLIC_URL}/knockknock/audio/call_ringtone_audio.mp3`
);
